import { VariableType } from '../../../components/Table/types'
import { ChartYAxis } from '../../../pages/reporting/custom/components/chart/types'
import { TaskApplication } from '../../../pages/superuser/types'
import { BudgetingScenario } from '../../../features/scenario/types/BudgetingScenario'
import { ReportDataType } from '../reports/types'
import { GraphType } from '../../../pages/reporting/custom/components/chart/ChartTypeSelect'
import { Dimension } from '../../../features/dimension/types/Dimension'
import { Formula } from '../../../features/formulas/types/Formula'
import { Company } from '../../../types/company/Company'

type ContextType = Record<string, string>

export enum OffsetUnit {
  year = 'year',
  month = 'month',
  week = 'week',
  day = 'day'
}

export enum FunctionCategoryValue {
  Division = 'div',
  Difference = 'diff',
  Growth = 'growth',
  DivisionFull = 'division',
  CommonSize = 'commonSize',
  Sum = 'sum',
  Percentage = 'percentage'
}

export type CustomReportCategoryType =
  | 'root'
  | 'company'
  | 'dimension'
  | 'periodGroup'
  | 'function'
  | 'keyFigureId'
  | 'formulaId'
  | 'reference'

export interface CustomReportCategory {
  id?: string
  title?: string
  type: CustomReportCategoryType
  value?: string | string[] | number | number[]
  argumentId?: number | null
  color?: string
  children?: CustomReportCategory[]
  style?: CustomReportCategoryStyle
  dataType?: ReportDataType.actuals | ReportDataType.budget | ReportDataType.forecast
  context?: ContextType
  budgetingScenarioId?: BudgetingScenario['id']
  startDate?: string
  endDate?: string
  offset?: number
  offsetUnit?: OffsetUnit
  // evaluated in backend
  budgetingScenario?: BudgetingScenario
  company?: Company
  dimension?: Dimension
  formulas?: Partial<Formula>[]
  variableType?: VariableType
  accountingSoftware?: TaskApplication
}

export enum DashStyle {
  Dash = 'Dash',
  DashDot = 'DashDot',
  Dot = 'Dot',
  LongDash = 'LongDash',
  LongDashDot = 'LongDashDot',
  LongDashDotDot = 'LongDashDotDot',
  ShortDash = 'ShortDash',
  ShortDashDot = 'ShortDashDot',
  ShortDashDotDot = 'ShortDashDotDot',
  ShortDot = 'ShortDot',
  Solid = 'Solid'
}

export interface CustomReportCategoryStyle {
  type?: GraphType
  dashStyle?: DashStyle
  zIndex?: number
  color?: string
  yAxis?: ChartYAxis
}

export type CustomReportCategoryRow = Omit<CustomReportCategory, 'children' | 'type'> & {
  id: number
  company: CustomReportCategory
  dimension?: CustomReportCategory
  function?: CustomReportCategory
  periodGroup?: CustomReportCategory
  leaf: CustomReportCategory
  type: undefined
  children?: CustomReportCategoryRow[]
  values: {
    [key: string]: number | undefined
  }
}
